import useCurrentUser from '~/hooks/useCurrentUser'
import { useTimeSpentStatsQuery } from '~/redux/apis/user-stats-api'

export default function useTimeSpentReport(familyMemberId?: number) {
  const user = useCurrentUser()

  const {
    data: timeSpentReport,
    isFetching,
    isLoading,
  } = useTimeSpentStatsQuery(familyMemberId ? { familyMemberId } : {}, { skip: user == null })

  return {
    isLoading: isFetching || isLoading,
    timeSpent: timeSpentReport?.timeSpent ?? 10,
  }
}
